import { capitalize } from '@material-ui/core';

import { StateIconProps } from '@spotify/confidence-core-react';
import {
  WorkflowInstanceFragment,
  WorkflowV1WorkflowInstanceCheckState,
} from '@spotify/confidence-graphql';

type UseStateCellOptions = Pick<
  WorkflowInstanceFragment,
  'state' | 'pendingTransition' | 'checks'
>;

type UseStateCellResult = Pick<
  StateIconProps,
  'state' | 'label' | 'error' | 'incomplete'
>;

export const useStateCell = (
  workflowInstance: UseStateCellOptions,
): UseStateCellResult => {
  const { state, checks, pendingTransition } = workflowInstance;

  const error = checks.some(
    check => check.state === WorkflowV1WorkflowInstanceCheckState.Failed,
  );

  if (pendingTransition) {
    return {
      state: 'transition',
      label: capitalize(state),
      error,
    };
  }

  if (state === 'draft') {
    return {
      state: 'draft',
      label: 'Draft',
      incomplete: error,
    };
  }

  if (
    state === 'ended' ||
    state === 'archived' ||
    state === 'live' ||
    state === 'active'
  ) {
    return {
      state,
      label: capitalize(state),
      error,
    };
  }
  throw new Error(`Unknown state: ${state}`);
};
